var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-card-master"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-master",
    clipPath: "url(#clip-card-master)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33617",
    "data-name": "Path 33617",
    d: "M15.245,17.831H8.755V6.168h6.49Z",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33618",
    "data-name": "Path 33618",
    d: "M9.167,12A7.4,7.4,0,0,1,12,6.169a7.417,7.417,0,1,0,0,11.662A7.406,7.406,0,0,1,9.167,12Z",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33619",
    "data-name": "Path 33619",
    d: "M24,12a7.416,7.416,0,0,1-12,5.831A7.417,7.417,0,0,0,12,6.169,7.416,7.416,0,0,1,24,12Z",
    fill: "#f79e1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMaster);
export default __webpack_public_path__ + "static/media/card-master.9957a801e09dc05e75858922616c26b8.svg";
export { ForwardRef as ReactComponent };